/** Per-session exposure latch that records which exposure keys have already been handled. */
export interface IExposureSessionLatch {
  clear(): void;
  hasHandled(exposureKey: string): boolean;
  markHandled(exposureKey: string): void;
}

/** Creates an in-memory exposure latch backed by a Set of handled exposure keys. */
export const createExposureSessionLatch = (): IExposureSessionLatch => {
  const handledExposures = new Set<string>();

  return {
    clear: () => handledExposures.clear(),
    hasHandled: (exposureKey: string) => handledExposures.has(exposureKey),
    markHandled: (exposureKey: string) => {
      handledExposures.add(exposureKey);
    },
  };
};
